/**
 * Layout-only parent route for /accounts/*.
 * See `_app.deals.tsx` for the rationale.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/accounts")({
  component: AccountsLayout,
});

function AccountsLayout() {
  return <Outlet />;
}
